import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {
  Inject,
  Injectable,
  PLATFORM_ID,
} from '@angular/core';

import {
  BehaviorSubject,
  Subject,
} from 'rxjs';
import {
  apiRequest,
  ServiceBase,
} from 'services';

import { Changepwd } from '@models/changepwd';

@Injectable({
  providedIn: "root"
})
export class LoginService extends ServiceBase {
  LoginSuccess: Subject<any>;
  TokenValid: BehaviorSubject<any>;
  LanguaggeSuccess: Subject<any>;
  ForgotEmail: Subject<any>;
  ChangePasswordSuccess: Subject<any>;
  SocialLoginSuccess: Subject<any>;
  SaveBranchSuccess: Subject<any>;
  GetIndustryTypesSuccess: Subject<any>;
  SaveOrganizationSuccess: Subject<any>;
  SaveOrganizationUserSuccess: Subject<any>;
  GetOrganizationDetailsSuccess: Subject<any>;
  InviteOrganizationUserSuccess$: Subject<any>;

  constructor(http: HttpClient, @Inject(PLATFORM_ID) private platformId) {
    super(http);
    this.LanguaggeSuccess = new Subject<any>();
    this.ForgotEmail = new Subject<any>();
    this.LoginSuccess = new Subject();
    this.TokenValid = new BehaviorSubject<any>(undefined);
    this.ChangePasswordSuccess = new Subject<any>();
    this.SocialLoginSuccess = new Subject<any>();
    this.GetIndustryTypesSuccess = new Subject<any>();
    this.SaveBranchSuccess = new Subject<any>();
    this.SaveOrganizationSuccess = new Subject<any>();
    this.SaveOrganizationUserSuccess = new Subject<any>();
    this.GetOrganizationDetailsSuccess = new Subject<any>();
    this.InviteOrganizationUserSuccess$ = new Subject<any>();

  }

  getOrganizationDetailsForUser(data) {
    this.post({ url: 'Login/Organization/v1/GetOrgDetails', onNotify: this.GetOrganizationDetailsSuccess, data })
  }

  getAllIndustryTypes() {
    this.get({ url: 'Login/YtbCommon/v1/GetAllIndustryTypes', onNotify: this.GetIndustryTypesSuccess })
  }


  saveBranch(data) {
    this.post({ url: 'Login/Organization/v1/UpsertOrgBanchDetails', onNotify: this.SaveBranchSuccess, data })
  }

  saveOrganization(data) {
    this.post({ url: 'Login/Organization/v1/UpsertOrgDetails', onNotify: this.SaveOrganizationSuccess, data })
  }

  saveOrganizationUser(data) {
    this.post({ url: 'Login/Organization/v1/UpsertOrgUser', onNotify: this.SaveOrganizationUserSuccess, data })
  }


  inviteOrgUser(data) {
    this.post({ url: 'Login/InviteLink/v1/InviteOrgEmployee', onNotify: this.InviteOrganizationUserSuccess$, data })

  }



  /**
   * @author : Ryan
   * @description : This method is used to validate the token
   * @apiEndPoint : 'user/me'
   */
  validateToken() {
    this.get<any>({ url: "user/me", onNotify: this.TokenValid });
  }

  getLanguagges() {
    this.get<any>({
      url: "Common/Common/v1/languages",
      onNotify: this.LanguaggeSuccess
    });
  }

  emailforforgotpassword(data) {
    this.post<any>({
      url: "Common/UserCredentials/v1/B2CForgetpassword",
      data: data,
      onNotify: this.ForgotEmail
    });
  }

  newLogin(data) {
    this.post<any>({
      url: "Login/UserLogin/v1/B2CLogin",
      data: data,
      onNotify: this.LoginSuccess, operationKey: "Login_Issue"
    });
  }

  changenewpwd(changereg: Changepwd) {
    this.post<any>({
      url: "Common/UserCredentials/v1/UpdateUsercredential",
      data: changereg,
      onNotify: this.ChangePasswordSuccess
    } as apiRequest<any>);
  }

  // Common/UserCredentials/v1/B2CForgetpassword

  googleLogin() {
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
      // window.open("http://localhost:8073/YTB/api/user/google", "_self");
    }
  }

  socialLogin(Obj) {
    this.post<any>({
      url: "user/socialLogin",
      data: Obj,
      onNotify: this.SocialLoginSuccess
    });
  }
}
